<template>
    <div id="contenedor-principal" class="container-fluid">
        <div id="encabezados">
            <h1>ADMINISTRACIÓN DE SUBMENÚS</h1>
            <h4>Agrega, modifica o da de baja los submenús de la página web</h4>
        </div>
        <transition name="fade">
            <div class="seccion-filtrosDeBusqueda" v-show="!ocultarFiltros">
                <div class="titulo-contendor">
                    <div class="form-inline justify-content-between">
                        <h4>Filtros de búsqueda</h4>
                        <button v-if="submenus.actualizacionDeFiltros.actualizar" @click="submenus.actualizacionDeFiltros.actualizar = false, submenus.actualizacionDeFiltros.contRender += 1" type="button" class="btn btn-sm btn-light"><i class="fas fa-sync-alt"></i></button>
                    </div>
                </div>
                <CFiltrosDeBusquedaSubMenus
                    :ID_COMPONENTE="C_FILTROS_BUSQUEDA_ID"
                    v-on:BusquedaDeSubmenus="evtRealizarBusquedaDeSubmenus"
                    class="contenedor-gris"
                    :key="'KFiltrosDeBusquedaVASMPW' + submenus.actualizacionDeFiltros.contRender"></CFiltrosDeBusquedaSubMenus>
            </div>
        </transition>
        <div :class="[(ocultarFiltros) ? 'd-flex justify-content-center align-items-center seccion-filtrosDeBusqueda' : 'd-flex justify-content-center align-items-center mt-4']">
            <hr style="flex: 1; border: none; height: 3px; background: white; margin-right: 2em;">
                <button  type="button" class="btn btn btn-light" @click="ocultarFiltros = !ocultarFiltros">
                    <i :class="[(ocultarFiltros) ? 'fas fa-caret-square-down' : 'fas fa-caret-square-up']"></i>&nbsp;&nbsp;{{ (ocultarFiltros) ? 'Mostrar' : 'Ocultar'}} filtros
                </button>
            <hr style="flex: 1; border: none; height: 3px; background: white;  margin-left: 2em;">
        </div>
        <div id="seccion-crud" class="mt-4">
            <div class="titulo-tabla">
                <div class="row">
                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 pr-2 pt-1"><h4>Administración de submenús</h4></div>
                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1 d-flex justify-content-end">
                        <div class="d-flex">
                            <button v-if="submenus.memoria.length > 0" @click="evtMostrarModalOrdenamiento" type="button" class="mr-2 btn btn-light"><i class="fas fa-sort-numeric-up"></i></button>
                            <button type="button" @click="evtMostrarFormulario" class="btn btn btn-light mr-4"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="tabla-submenus-SICPO-VADSM" class="contenedor-gris table-responsive">
                <div v-if="submenus.seleccionados.length > 1" id="accion-estatus-submenus" class="form-inline justify-content-end">
                    <h6 @click="evtMostrarModalCambioEstatus" class="mr-3"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Cambiar estatus</h6>
                </div>
                <table
                    class="table table-striped table-light table-hover"
                    id="tabla-submenus"              
                    data-toggle="table"
                    data-pagination="true"
                    data-undefined-text="Sin información"
                    data-maintain-selected="true"  
                    data-page-size = "5"
                    data-page-list="[5,10,20]"
                    data-click-to-select="false"
                    data-search="true">
                    <thead class="thead-encabezado">
                        <tr>
                            <th data-halign="center" data-width="5" data-align="center" data-checkbox="true"></th>
                            <th data-halign="center" data-width="10" data-align="center" data-field="SubmenuId" data-sortable="true">
                                Folio
                            </th>
                            <th data-halign="center" data-width="25" data-align="center" data-field="tituloPadre" data-sortable="true">
                                pertenece a
                            </th>
                            <!-- <th data-halign="center" data-width="20" data-align="center" data-field="Menu.Titulo" data-sortable="true">
                                Menu
                            </th> -->
                            <th data-halign="center" data-width="30" data-align="center" data-field="Titulo" data-sortable="true">
                                Título
                            </th>
                            <!-- <th data-halign="center" data-width="20" data-align="center" data-field="SubmenuAlQuePertenezco.Titulo" data-sortable="true">
                                Submenu al que pertenece
                            </th> -->
                            <th data-events="operateEvents" id="switch-contenido-activo" data-width="10" data-field="EstaActivo.html" data-halign="center" data-align="center">
                                Activo
                            </th>
                            <th data-events="operateEvents" data-width="15" :data-formatter="this.formateadorHTMLAcciones()" data-halign="center" data-align="center">
                                Acciones
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
        <!-- MODAL PARA FORMULARIO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-formulario-submenus">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ formulario.tituloFormulario }}</h5>
                        <button  id="btn-cerrar-modal-formulario-submenus" class="close" @click="evtCerrarFormulario" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div v-if="formulario.mostrarErrores && !this.formularioEsValido()" class="form-group">
                            <div id="contenedor-error-formulario">
                                <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en Formulario</h6>
                                <span style="text-align: justify; display:block;">{{ formulario.mensajeError }}</span>
                            </div>
                        </div>
                        <div class="form-group d-flex align-items-center justify-content-between">
                            <i>Los campos con (*) son obligatorios.</i>
                            <button v-if="!formulario.esEdicion" type="button" @click="evtIniciarProcesoAltaSubmenu" class="btn btn btn-light"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                            <button v-if="formulario.esEdicion" type="button" @click="evtIniciarProcesoModificacionDeSubmenu" class="btn btn btn-light"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                        </div>
                        <div class="form-group contenedor-color-negro container-fluid">
                            <!-- SWITCH TIPO SUBMENU AL QUE PERTENECE -->
                            <div class="">
                                <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                    <label :class="[formulario.esSubmenuPadre ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.esSubmenuPadre = true">
                                        <input type="radio" name="options" id="perteneceAsubmenuRadio" autocomplete="off"  checked>ES SUBMENU PRINCIPAL
                                    </label>
                                    <label :class="[!formulario.esSubmenuPadre ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.esSubmenuPadre = false">
                                        <input type="radio" name="options" id="noPerteneceAsubmenuRadio" autocomplete="off" >ES SUBMENU SECUNDARIO
                                    </label>
                                </div>
                            </div>
                            <hr style="height:2px;border:none;color:#FFF;background-color:#FFF; margin-top: 0;"/>
                            <!-- INFORMACION DE HERENCIA SUBMENU -->
                            <div class="form-group mt-4" v-show="formulario.esEdicion && !formulario.mostrarOpcionesHerencia">
                                <div class="form-inline" v-if="submenus.seleccionadoEdicion != null">
                                    <h6>{{ this.campoRequeridoEsValido(submenus.seleccionadoEdicion.Menu) 
                                        ? 'Pertenece a Menu [ ' + submenus.seleccionadoEdicion.Menu.Titulo + ' ]' : 'Pertenece a Submenu [ ' + submenus.seleccionadoEdicion.SubmenuAlQuePertenezco.Titulo + ' ]' }}</h6>
                                    <button type="button" class="btn btn-sm btn-info ml-2" @click="formulario.mostrarOpcionesHerencia = true"><i class="fas fa-exchange-alt"></i>&nbsp;Cambiar</button>
                                </div>
                            </div>
                            <div class="form-group mt-4" v-show="formulario.esEdicion && formulario.mostrarOpcionesHerencia">
                                <button type="button" class="btn btn-sm btn-info" @click="formulario.mostrarOpcionesHerencia = false"><i class="fas fa-undo-alt"></i>&nbsp;regresar seleccion</button>
                            </div>
                            <div id="seccion-herencia-submenu" v-show="formulario.mostrarOpcionesHerencia">
                                <div class="form-group mt-4">
                                    <h6>Submenú pertenece a (*)&nbsp;
                                        <i v-if="formulario.mostrarErrores && this.perteneAEsValido()" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="formulario.mostrarErrores && !this.perteneAEsValido()" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                </div>
                                <!-- TIPO MENU -->
                                <div class="form-group">
                                    <h6>Menú</h6>
                                    <C004Menus  
                                        class="p-0 m-0" 
                                        v-on:valorParaElPadre="evtCambioMenu" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="formulario.catalogoMenus.ID" 
                                        :parametros="formulario.catalogoMenus.parametros" 
                                        :valorDefinido="formulario.catalogoMenus.valorDefinido" 
                                        :key="formulario.catalogoMenus.KEY + formulario.catalogoMenus.contRender"></C004Menus>
                                </div>
                                <!-- TIPO DE SUBMENU MENU -->
                                <div class="form-group">
                                    <h6>Submenú</h6>
                                    <C006Submenus  
                                        class="p-0 m-0" 
                                        v-on:valorParaElPadre="evtCambioSubmenu" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="formulario.catalogoSubmenu.ID" 
                                        :parametros="formulario.catalogoSubmenu.parametros" 
                                        :valorDefinido="formulario.catalogoSubmenu.valorDefinido" 
                                        :key="formulario.catalogoSubmenu.KEY + formulario.catalogoSubmenu.contRender"></C006Submenus>
                                </div>
                                <!-- SUBMENUS HIJOS -->
                                <CSelectRecursivo
                                    v-if="formulario.catalogoSubmenu.subMenuSeleccionado != null && formulario.catalogoSubmenu.subMenuSeleccionado.SubmenusQueMePertenecen.length > 0"
                                    v-on:SeleccionoElemento="evtSeleccionSubmenuHijo"
                                    :nodoPrincipal="formulario.catalogoSubmenu.subMenuSeleccionado"
                                    :identificadores="{ nodosHijos: 'SubmenusQueMePertenecen', llave: 'SubmenuId', nombre: 'Titulo' }"
                                    :texoSingularEnSelect="'un tipo de submenu'"
                                    :key="formulario.catalogoSubmenu.hijos.KEY + formulario.catalogoSubmenu.hijos.contRender"></CSelectRecursivo>
                            </div>
                            <!-- INPUTS TITULO SUBMENU -->
                            <hr v-if="formulario.catalogoSubmenu.subMenuSeleccionado != null && formulario.catalogoSubmenu.subMenuSeleccionado.SubmenusQueMePertenecen.length > 0" style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                            <div class="row">
                                <!-- TITULO SUBMENU -->
                                <div class="form-group col-xs-8 col-sm-8 col-md-8 col-lg-8 pr-3 pt-1">
                                    <h6>Título de submenú (*)&nbsp;
                                        <i v-if="formulario.mostrarErrores && this.campoRequeridoEsValido(formulario.titulo)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="formulario.mostrarErrores && !this.campoRequeridoEsValido(formulario.titulo)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                    <input v-model="formulario.titulo" type="text" id="titulo_submenu_vadsm" class="form-control" placeholder="Ingrese el título del submenú" />
                                </div>
                                <!-- SWITCH PARA RESALTAR TITULO SUBMENU -->
                                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3 pt-1">
                                    <h6 class="pr-2">Resaltar</h6>
                                    <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                        <label :class="[formulario.resaltarTitulo ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.resaltarTitulo = true">
                                            <input type="radio" name="options" id="radioResaltarTitulo" autocomplete="off"  checked>Si
                                        </label>
                                        <label :class="[!formulario.resaltarTitulo ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.resaltarTitulo = false">
                                            <input type="radio" name="options" id="radioNoResaltarTitulo" autocomplete="off" >No
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- SWITCH ES DESCARGA -->
                            <!-- <div class="mt-0" v-show="!formulario.esSubmenuPadre"> -->
                            <div class="mt-0">
                                <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                    <label :class="[formulario.esDescarga ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.esDescarga = true">
                                        <input type="radio" name="options" id="radioEsDescarga" autocomplete="off"  checked>SUBMENU ES DESCARGA
                                    </label>
                                    <label :class="[!formulario.esDescarga ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.esDescarga = false">
                                        <input type="radio" name="options" id="radioNoEsDescarga" autocomplete="off" >SUBMENU ES RUTA DE ACCESO
                                    </label>
                                </div>
                            </div>
                            <!-- SI ES DESCARGA MUESTRA SUBIDOR -->
                            <div class="form-inline" v-if="(this.campoRequeridoEsValido(submenus.seleccionadoEdicion) && submenus.seleccionadoEdicion.EsDescarga) && 
                                                            formulario.esEdicion && !formulario.archivo.esConSubidor && formulario.esDescarga">
                                <i class="pr-2">Archivo de acceso actual: {{ this.obtenerNombreDelArchivo(submenus.seleccionadoEdicion.RutaParaAccesar) }}</i>
                                <button type="button" class="btn btn-sm btn-success" @click="evtDescargarArchivo(submenus.seleccionadoEdicion.RutaParaAccesar)"><i class="fas fa-file-download"></i>&nbsp;Descargar</button>
                            </div>
                            <!-- <div class="row" v-show="formulario.esDescarga && !formulario.esSubmenuPadre"> -->
                            <div class="row" v-show="formulario.esDescarga">
                                <div class="form-group col-xs-8 col-sm-8 col-md-8 col-lg-8 pr-3 pt-1">
                                    <h6>{{ this.marcarCampoDeFormularioComoUrgente('Seleccione el archivo de descarga') }}&nbsp;
                                        <i v-if="formulario.mostrarErrores && this.campoRequeridoEsValido(formulario.archivo.objeto) && !formulario.esSubmenuPadre" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="formulario.mostrarErrores && !this.campoRequeridoEsValido(formulario.archivo.objeto) && !formulario.esSubmenuPadre" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                    <input type="file" id="archivo_submenu" class="form-control" v-on:change="evtSubidorDeArchivo($event)" :accept="formulario.archivo.EXTENSIONES" />
                                </div>
                                <!-- SWITCH PARA MOSTRAR EN VISOR -->
                                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3 pt-1">
                                    <h6 class="pr-2">Mostrar en visor</h6>
                                    <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                        <label :class="[formulario.mostrarEnVisor ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.mostrarEnVisor = true">
                                            <input type="radio" name="options" id="radioResaltarTitulo" autocomplete="off"  checked>Si
                                        </label>
                                        <label :class="[!formulario.mostrarEnVisor ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.mostrarEnVisor = false">
                                            <input type="radio" name="options" id="radioNoResaltarTitulo" autocomplete="off" >No
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- SI NO MUESTRA INPUT PARA LA RUTA DE ACCESO -->
                            <!-- <div class="form-group" v-show="!formulario.esDescarga && !formulario.esSubmenuPadre"> -->
                            <div class="form-group" v-show="!formulario.esDescarga">
                                <h6>{{ this.marcarCampoDeFormularioComoUrgente('Url de acceso') }}&nbsp;
                                    <i v-if="formulario.mostrarErrores && this.campoRequeridoEsValido(formulario.url) && !formulario.esSubmenuPadre" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formulario.mostrarErrores && !this.campoRequeridoEsValido(formulario.url) && !formulario.esSubmenuPadre" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <input v-model="formulario.url" type="text" id="ruta_acceso" class="form-control" placeholder="Ingrese la url de acceso del submenú" />
                            </div>
                            <!-- SWITCH PERMITE SUBIR CONTENIDO -->
                            <!-- <div class="mt-0" v-show="!formulario.esSubmenuPadre"> -->
                            <div class="mt-0">
                                <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                    <label :class="[formulario.permiteSubirContenido ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.permiteSubirContenido = true">
                                        <input type="radio" name="options" id="radioEsDescarga" autocomplete="off"  checked>PERMITE SUBIR CONTENIDO
                                    </label>
                                    <label :class="[!formulario.permiteSubirContenido ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.permiteSubirContenido = false">
                                        <input type="radio" name="options" id="radioNoEsDescarga" autocomplete="off" >NO PERMITE SUBIR CONTENIDO
                                    </label>
                                </div>
                            </div>
                            <hr v-if="formulario.iconos.lista.length > 0" style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
                            <!-- ICONOS DE SUBMENU -->
                            <div class="form'group" v-if="formulario.iconos.lista.length > 0">
                                <h6>Seleccione el icono del submenu</h6>
                                <CListaDeImagenes  
                                    :idDivPadre="formulario.iconos.ID"
                                    :esParaIconos="true"
                                    :estilosExtraDiv="'display: inline-block; border-radius:8px; overflow-y: auto; background-color:#212529; max-height: 212px;'" 
                                    :estilosExtraUl="'margin-left: 3.5em; margin-bottom: 1em;  padding-top: 1em;'" 
                                    v-on:cargarImagenes="recargarIconos" 
                                    v-on:valorParaElPadre="evtSeleccionDeIcono" 
                                    :idListaDeImagenes="formulario.iconos.ID + '-LI-VADSM'" 
                                    :listaDeImagenes="formulario.iconos.lista"
                                    :ref="formulario.iconos.REF"
                                    :key="formulario.iconos.KEY + formulario.iconos.contRender"></CListaDeImagenes>
                            </div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL ORDENAMIENTO DE SUBMENUS -->
         <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-ordenamiento-submenusPW">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ordenamiento de submenús</h5>
                        <button  id="btn-cerrar-modal-ordenamiento-submenusPW" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div v-if="ordenamiento.listaOrdenamiento.length > 0">
                            <div id="informacion-ordnamiento" class="form-inline">
                                <i class="fas fa-info-circle"></i>&nbsp;
                                <i>Selecciona y desplaza los submenús para cambiar el orden.</i>
                            </div>
                            <div id="lista-ordenamiento-submenus" class="mt-2">
                                <ClistaOrdenable
                                    :elementos="ordenamiento.listaOrdenamiento"
                                    :referenciasElemento="ordenamiento.REFERENCIAS"
                                    :informacionAmostrar="ordenamiento.CAMPOS"
                                    v-on:ModificacionEnListaDeElementos="evtOrdenDeSubmenusSeModifico"></ClistaOrdenable>
                            </div>
                            <div class="d-flex justify-content-end mt-4">
                                <button type="button" class="btn btn-sm btn-light mr-2" @click="evtIniciarCambioOrdenSubmenus(ordenamiento.TIPO.ALFABETICO)"><i class="fas fa-sort-alpha-down"></i>&nbsp;Ordenar alfabéticamente</button>
                                <button type="button" @click="evtIniciarCambioOrdenSubmenus(ordenamiento.TIPO.DESPLAZAMIENTO)" class="btn btn-sm btn-light"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                            </div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- FIN MODAL DE ORDENAMIENTO -->
         <!-- MODAL COFIRMACION -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-informativo-VADSM">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalInformativo.titulo }}</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>{{ modalInformativo.mensaje }}</h6>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="modalInformativo.funcionConfirmar"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="modalInformativo.funcionCancelar"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-cambio-estatus-VASM">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <div class="form-inline justify-content-center mb-3">
                                <i v-if="submenus.activarVariosSubmenus" class="fas fa-eye icono-activacion-submenus"></i>
                                <i v-if="!submenus.activarVariosSubmenus" class="fas fa-eye-slash icono-activacion-submenus"></i>
                            </div>
                            <div class="form-inline justify-content-center text-center mb-2">
                                <h4 v-if="!submenus.activarVariosSubmenus">El submenú se dejara de mostrar en la página web</h4>
                                <h4 v-if="submenus.activarVariosSubmenus">El submenú se mostrara en la página web</h4>
                            </div>
                            <div class="form-inline justify-content-center"> 
                                <h6 class="pr-2">Estatus activo:</h6>
                                <label class="switch">
                                    <input id="switch-cambio-estatus-modal-VASM" type="checkbox" @change="evtSwitchActivacionVariosSubmenus">
                                    <div class="slider"></div>
                                </label>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1 acciones-activacion-submenus"><button type="button" class="btn btn-block btn-primary" @click="evtCerrarModalActivacion"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                            <div class="col-6 pr-1 pl-1 acciones-activacion-submenus"><button type="button" class="btn btn-block btn-primary" @click="evtCambiarEstatusSubmenus"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import axios from 'axios'
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"
import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'
import CSelectRecursivo from '@/components/SICPO/Comun/CSelectRecursivo.vue'
import ClistaOrdenable from '@/components/SICPO/Comun/ClistaOrdenable.vue'
import catalogos from '@/../static/js/catalogos'
import CFiltrosDeBusquedaSubMenus from '@/components/SICPO/PaginaWeb/Submenus/CFiltrosDeBusquedaSubMenus.vue';
import CListaDeImagenes from '../../Comun/CListaDeImagenes.vue'
import C006Submenus from '../../Catalogos/C006Submenus.vue'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'

export default {
    directives: {
        tooltipF
    },
    components: {
        C004Menus: catalogos.SICPO.C004Menus,
        C006Submenus: C006Submenus,
        CListaDeImagenes,
        C001PaginaInicio: catalogos.SICPO.C001PaginaInicio,
        CFiltrosDeBusquedaSubMenus: CFiltrosDeBusquedaSubMenus,
        CSelectGenerico,
        CSelectRecursivo,
        ClistaOrdenable
    },
    data() {
        return {
            enumeraciones,
            C_FILTROS_BUSQUEDA_ID: 'CFIltosDeBusqueda-VASPW',
            ocultarFiltros: false,
            modalInformativo: {
                titulo: 'Mensaje del sistema',
                mensaje: '',
                funcionConfirmar: () => {},
                funcionCancelar: () => {}
            },
            formulario: {
                esEdicion: false,
                tituloFormulario: 'Formulario alta de submenu',
                mostrarErrores: false,
                mensajeError: null,
                esSubmenuPadre: false,
                catalogoMenus: {
                    ID: 'CMenus-VADSM',
                    REF: 'REFMenus-VADSM',
                    parametros: { MenuId: null, SubmenuId: null, TipoPosicionId: null, PaginaWebId: null, PaginaDeInicioId: null, ConInactivos: false, ConSubmenus: false, ConTodosLosSubmenus: false, ConTodasLasPaginasWebDelSubmenu: false, ConPaginasWeb: false, ConPaginasDeInicio: false, ConOrdenamientoDelMenu: false, ConOrdenamientoDelSubmenu: false },
                    valorDefinido: -1,
                    menuSeleccionado: null,
                    KEY: 'KMenus-VADSM',
                    contRender: 0
                },
                catalogoSubmenu: {
                    ID: 'CSubMenus-VADSM',
                    REF: 'REFSubMenus-VADSM',
                    parametros: { SubmenuId: null, MenuId: null, PaginaWebId:null, SubmenuIdDelQuePertenezco:null, SubmenuIdQueMePertenece:null, ConInactivos:false, ConMenu:false, ConMenusLosSubmenus:false, ConSubmenusQueMePertenecen:true, ConTodosLosSubmenusQueMePertenecen: true, ConTodasLasPaginasWebDelSubmenu:false, ConSubmenuDelQueDesciende:false, ConPaginasWeb:false, ConOrdenamiento:false, ConOrdenamientoDeLosSubmenus:false, SoloPermiteSubirContenido:false },
                    valorDefinido: -1,
                    subMenuSeleccionado: null,
                    KEY: 'KSubMenus-VADSM',
                    contRender: 0,
                    hijos: {
                        KEY: 'KSubMenuHijo-VADSM',
                        contRender: 0,
                        seleccionado: null,
                        historialDeSeleccion: []
                    }
                },
                titulo: null,
                resaltarTitulo: false,
                esDescarga: false,
                archivo: {
                    EXTENSIONES: '.PDF,XLSX',
                    esConSubidor: false,
                    objeto: null,
                    IDENTIFICADOR: 'ARCHIVO-SUBMENU'
                },
                url: null,
                mostrarEnVisor: false,
                permiteSubirContenido: false,
                iconos: {
                    ID: 'ID-ListaDeIconos-VADSM',
                    REF: 'REF-ListaDeIconos-VADSM',
                    seleccionado: null,
                    lista: [],
                    KEY: 'KEY-ListaDeIconos-VADSM',
                    contRender: 0
                },
                mostrarOpcionesHerencia: true
            },
            submenus: {
                BD: [],
                memoria: [],
                seleccionado: null,
                seleccionados: [],
                filtrosDeBusqueda: null,
                activarVariosSubmenus: false,
                tituloPadreSubmenu: '',
                seleccionadoEdicion: null,
                actualizacionDeFiltros: { actualizar: false, contRender: 0 }
            },
            ordenamiento: {
                listaOrdenamiento: [],
                listaNuevoOrden: [],
                REFERENCIAS: { folio: 'SubmenuId', orden: 'OrdenDelSubmenu',fechaPublicacion: 'fp', descripcion: 'Titulo' },
                CAMPOS: { folio: true, fechaPublicacion: false, descripcion: true },
                TIPO: { DESPLAZAMIENTO: 1, ALFABETICO: 2 }
            }
        }
    },
    methods: {
        evtIniciarCambioOrdenSubmenus: async function(tipoDeOrdenamiento) {
            const { TIPO } = this.ordenamiento;
            switch(tipoDeOrdenamiento) {
                case TIPO.DESPLAZAMIENTO:
                    const SUBMENUS_NUEVO_ORDEN = await Promise.resolve(this.actualizarOrdenEnListaDeSubmenus());
                    if(SUBMENUS_NUEVO_ORDEN.length > 0) {
                         const PETICION = { Submenus: SUBMENUS_NUEVO_ORDEN, esPrueba: false };
                         $("#modal-ordenamiento-submenusPW").modal('hide');
                         await Promise.resolve(this.modificarOrdenamientoSubmenusBD(PETICION, tipoDeOrdenamiento));
                    }
                    break;
                case TIPO.ALFABETICO:
                        let peticion = {};
                        peticion.Submenus = this.submenus.BD.filter(sbd => sbd.Activo).map(s => {
                            let submenuObj = {
                                SubmenuId: s.SubmenuId, 
                                Titulo: s.Titulo,
                                ResaltarElTitulo: false, 
                                EsDescarga: false, 
                                SeMuestraEnVisor: false, 
                                Activo: false, 
                                PermiteSubirContenido: false
                            }
                            return submenuObj;
                        });
                        peticion.esPrueba = false;
                        $("#modal-ordenamiento-submenusPW").modal('hide');
                        await Promise.resolve(this.modificarOrdenamientoSubmenusBD(peticion, tipoDeOrdenamiento));
                    break;
                default:
                    break;
            }
        },
        modificarOrdenamientoSubmenusBD: async function(peticionAPI, TIPO_ORDENAMIENTO) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_MODIFICAR = (TIPO_ORDENAMIENTO == this.ordenamiento.TIPO.DESPLAZAMIENTO)
                    ? api.SICPO.sistema.paginaweb.administracionDeSubmenus.ModificarOrdenamientoDeSubmenusPW
                    : api.SICPO.sistema.paginaweb.administracionDeSubmenus.OrdenarAlfabeticamenteSubmenusPW;
                let urlApi = SERVIDOR + METODO_API_MODIFICAR;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_AGREGAR_SUBMENU = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_AGREGAR_SUBMENU.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                    $("#modal-ordenamiento-submenusPW").modal('show');
                } 
                else {
                    const ES_PARA_ACTUALIZAR = true;
                    await Promise.resolve(this.obtenerSubmenusBD(ES_PARA_ACTUALIZAR, Satisfactorio));
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        actualizarOrdenEnListaDeSubmenus: async function() {
            let listaOrdenada = [];
            if(this.campoRequeridoEsValido(this.ordenamiento.listaNuevoOrden) && this.ordenamiento.listaNuevoOrden.length > 0) {
                let orden = 1;
                listaOrdenada = this.ordenamiento.listaNuevoOrden.map(s => {
                    let submenuObj = { 
                        SubmenuId: s.SubmenuId, 
                        ResaltarElTitulo: false, 
                        EsDescarga: false, 
                        SeMuestraEnVisor: false, 
                        Activo: false, 
                        PermiteSubirContenido: false, 
                        OrdenDelSubmenu: orden };
                    orden ++;
                    return submenuObj;
                });
            }
            return listaOrdenada;
        },
        evtMostrarModalOrdenamiento: function() {
            $("#modal-ordenamiento-submenusPW").modal('show');
        },
        evtOrdenDeSubmenusSeModifico: function(editado, listaDeSubmenus) {
            this.ordenamiento.listaNuevoOrden = listaDeSubmenus;
            console.log('listaDeSubmenus::nuevoOrden::',this.ordenamiento.listaNuevoOrden);
        },
        evtIniciarProcesoModificacionDeSubmenu: async function() {
            const FORMULARIO_VALIDO = this.formularioEsValido();
            //console.log('FORMULARIO_VALIDO::',FORMULARIO_VALIDO);
            if(FORMULARIO_VALIDO) {
                this.formulario.mostrarErrores = false;
                const PETICION_API = await Promise.resolve(this.crearPeticionModificarSubmenu());
                // SOLO PARA DESARROLLO DESPUES COMENTAR
                for (var pair of PETICION_API.entries()) {
                    console.log(pair[0]+ ', ',pair[1]); 
                } 
                // FIN DE COMENTARIO
                $("#modal-formulario-submenus").modal('hide');
                await Promise.resolve(this.modificarSubmenuBD(PETICION_API));
            }
            else {
                this.formulario.mostrarErrores = true;
            }
        },
        modificarSubmenuBD: async function(peticionAPI) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_MODIFICAR = api.SICPO.sistema.paginaweb.administracionDeSubmenus.ModificarSubmenuPW;
                let urlApi = SERVIDOR + METODO_API_MODIFICAR;
                let peticionArchivos = true;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_AGREGAR_SUBMENU = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_AGREGAR_SUBMENU.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                    $("#modal-formulario-submenus").modal('show');
                } 
                else {
                    const ES_PARA_ACTUALIZAR = true;
                    this.limpiarFormulario();
                    console.log('modificarSubmenuBD::',Satisfactorio);
                    this.submenus.actualizacionDeFiltros.actualizar = true;
                    await Promise.resolve(this.obtenerSubmenusBD(ES_PARA_ACTUALIZAR, Satisfactorio));
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        marcarCampoDeFormularioComoUrgente: function(tituloInput) {
            return (this.formulario.esSubmenuPadre) ? `${ tituloInput }` : `${ tituloInput } (*)`;
        },
        obtenerNombreDelArchivo: function(rutaArchivo) {
            return (this.campoRequeridoEsValido(rutaArchivo)) ? rutaArchivo.replace(/^.*[\\\/]/, '') : '';
        },
        evtDescargarArchivo: function(rutaArchivo) { 
            var a = document.createElement("a");
            document.body.appendChild(a);
           /*  a.target = () ? "_blank" : ''; */
           /*  a.href = (this.formulario.archivos.esVinculoExterno) ? rutaArchivo : `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}` */
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}`
            a.click();
        },
        cargarFormularioParaModificaciones: async function(submenu) { 
            this.formulario.tituloFormulario = `Edición de submenú #Folio[ ${ submenu.SubmenuId } ]`;
            this.formulario.esEdicion = true;
            this.submenus.seleccionadoEdicion = this.submenus.BD.find(sbd => sbd.SubmenuId == submenu.SubmenuId);
            await Promise.resolve(this.llenarCamposTituloSubmenu(this.submenus.seleccionadoEdicion));
            this.formulario.mostrarOpcionesHerencia = false;
            this.formulario.titulo = this.submenus.seleccionadoEdicion.Titulo;
            await Promise.resolve(this.llenarCamposRutaDeAccesoSubmenu(this.submenus.seleccionadoEdicion));
            this.formulario.permiteSubirContenido = this.submenus.seleccionadoEdicion.PermiteSubirContenido;
            await Promise.resolve(this.llenarCamposIconosSubmenu(this.submenus.seleccionadoEdicion));
            $("#modal-formulario-submenus").modal('show');
        },
        llenarCamposIconosSubmenu: async function(submenu) { 
            const { TipoIcono } = submenu;
            if(this.campoRequeridoEsValido(TipoIcono)) {
                this.$nextTick(async () => {
                    $("#" + TipoIcono.TipoIconoId).trigger("click");
                    // cuando actualiza estos valores, la tabla se actualiza y pierde los valores de los switch
                    await Promise.resolve(this.persistirSwitchSubmenusActivos());
                });
            }
        },
        llenarCamposTituloSubmenu: async function(submenu) { debugger
            const { SubmenusQueMePertenecen, ResaltarElTitulo, RutaParaAccesar } = submenu;
            this.formulario.esSubmenuPadre = ((SubmenusQueMePertenecen != null && SubmenusQueMePertenecen.length > 0) || !this.campoRequeridoEsValido(RutaParaAccesar));
            this.formulario.resaltarTitulo = ResaltarElTitulo;
        },
        llenarCamposRutaDeAccesoSubmenu: async function(submenu) { debugger
            console.log('llenarCamposRutaDeAccesoSubmenu::',submenu);
            const { EsDescarga, RutaParaAccesar, SeMuestraEnVisor } = submenu;
            this.formulario.esDescarga = EsDescarga;
            if(EsDescarga)
                this.formulario.mostrarEnVisor = SeMuestraEnVisor;
            else 
                this.formulario.url = RutaParaAccesar;
        },
        evtCerrarModalActivacion: function() {
            $('#modal-cambio-estatus-VASM').modal("hide");
        },
        evtSwitchActivacionVariosSubmenus: function() {
            this.submenus.activarVariosSubmenus = $('#switch-cambio-estatus-modal-VASM').is(":checked");
        },
        evtMostrarModalCambioEstatus: function() {
            $('#modal-cambio-estatus-VASM').modal("show");
        },
        evtCambiarEstatusSubmenus: async function() {
            const OPCIONES_PETICION = null;
            const PETICON_API = await Promise.resolve(this.crearPeticioParaCambioDeEstatusSubmenus(OPCIONES_PETICION));
            console.log('PETICON_API::cambioestatus::',PETICON_API);
            const ES_CAMBIO_INDIVIDUAL = false;
            this.evtCerrarModalActivacion();
            await Promise.resolve(this.cambiarEstatusDeSubmenusBD(PETICON_API, ES_CAMBIO_INDIVIDUAL));
        },
        evtSeleccionSubmenuHijo: function(evento,objetoElemento) {
             // se obtiene submenu padre del submenu hijo seleccionado
            let idSubmenuPadreSTR = evento.target.getAttribute('id');
            let idCompuesto = idSubmenuPadreSTR.split('-');
            let idSubmenuPadre = idCompuesto[idCompuesto.length -1];
            //console.log('ID::SUBMENU::',idSubmenuPadre);

            this.formulario.catalogoSubmenu.hijos.seleccionado = (this.campoRequeridoEsValido(objetoElemento)) ? objetoElemento : null;
            // se agrega a historial de seleccion para obtener valor valido mas reciente cuando seleccione valores incorrectos (en este caso -1)
            // si es un valor valido lo agrega si no lo elimina del historial
            if(this.campoRequeridoEsValido(this.formulario.catalogoSubmenu.hijos.seleccionado)) {
                this.formulario.catalogoSubmenu.hijos.historialDeSeleccion.push(this.formulario.catalogoSubmenu.hijos.seleccionado);
            }
            else {
                /* this.formulario.catalogoSubmenu.hijos.historialDeSeleccion.pop(); */
                const ELEMENTO_SELECCIONADOS = this.formulario.catalogoSubmenu.hijos.historialDeSeleccion.filter(sh => sh.SubmenuAlQuePertenezco.SubmenuId == idSubmenuPadre);
                const ELEMENTO_SELECCIONADO = ELEMENTO_SELECCIONADOS[0];
                //console.log('ELEMENTO_SELECCIONADO::',ELEMENTO_SELECCIONADO);

                if(this.campoRequeridoEsValido(ELEMENTO_SELECCIONADO)) {
                    // elimina los historiales de submenus hijos
                    let indexDeElemento = this.formulario.catalogoSubmenu.hijos.historialDeSeleccion.findIndex(sh => sh.SubmenuId == ELEMENTO_SELECCIONADO.SubmenuId);
                    indexDeElemento ++; // metodo slice termina un numero antes del parametro que se le mande como final por eso se suma 1
                    //console.log('indexDeElemento::',indexDeElemento);
                    this.formulario.catalogoSubmenu.hijos.historialDeSeleccion = this.formulario.catalogoSubmenu.hijos.historialDeSeleccion.slice(0,indexDeElemento);

                    // elimina el historial de los submenus con el mismo submenu padre
                    this.formulario.catalogoSubmenu.hijos.historialDeSeleccion = this.formulario.catalogoSubmenu.hijos.historialDeSeleccion
                        .filter(sh => sh.SubmenuAlQuePertenezco.SubmenuId != ELEMENTO_SELECCIONADO.SubmenuAlQuePertenezco.SubmenuId);
                }
            }

            console.log('evtSeleccionSubmenuHijo::',this.formulario.catalogoSubmenu.hijos.seleccionado);
        },
        obtenerUltimaSeleccionValidaHijosDeSubmenu: function() {
            const ULTIMO_INDEX = (this.formulario.catalogoSubmenu.hijos.historialDeSeleccion.length - 1);
            let ultimaSeleccionValida = this.formulario.catalogoSubmenu.hijos.historialDeSeleccion[ULTIMO_INDEX];
            console.log('selecciones::',this.formulario.catalogoSubmenu.hijos.historialDeSeleccion);
            console.log('seleccionFinal::',ultimaSeleccionValida);
            return ultimaSeleccionValida;
        },
        evtSeleccionDeIcono: function(evento,iconoEstaSeleccionada) {
            const LLAVE_ICONO_SELECCIONADO = evento.target.getAttribute('id');
            if(iconoEstaSeleccionada)
                this.formulario.iconos.seleccionado = this.formulario.iconos.lista.find(i => i.llave == LLAVE_ICONO_SELECCIONADO);
            else
                this.formulario.iconos.seleccionado = null;
            this.$nextTick(async () => {
                await Promise.resolve(this.persistirSwitchSubmenusActivos());
            });
            console.log('icono::',this.formulario.iconos.seleccionado);
        },
        recargarIconos: function() {

        },
        evtCerrarFormulario: function() {
            this.limpiarFormulario();
            $("#modal-formulario-submenus").modal('hide');
        },
        /* obtenerSubmenusBD: async function(esParaActualizacion) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_GUARDAR = api.SICPO.sistema.paginaweb.administracionDeSubmenus.AgregarNuevoSubmenuPW;
                let urlApi = SERVIDOR + METODO_API_GUARDAR;
                let peticionAPI = {

                };
                let peticionArchivos = true;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_AGREGAR_SUBMENU = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_AGREGAR_SUBMENU.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(mensajeError);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(Satisfactorio);
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        }, */
        guardarNuevoSubmenuBD: async function(peticionAPI, esNuevoSubmenu) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_GUARDAR = api.SICPO.sistema.paginaweb.administracionDeSubmenus.AgregarNuevoSubmenuPW;
                let urlApi = SERVIDOR + METODO_API_GUARDAR;
                let peticionArchivos = true;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_AGREGAR_SUBMENU = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_AGREGAR_SUBMENU.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(mensajeError);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                    if(esNuevoSubmenu)
                        $("#modal-formulario-submenus").modal('show');
                } 
                else {
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(Satisfactorio);
                    if(esNuevoSubmenu)
                        this.limpiarFormulario();
                    this.submenus.actualizacionDeFiltros.actualizar = true;
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                if(esNuevoSubmenu)
                    $("#modal-formulario-submenus").modal('show');
            }
        },
        evtIniciarProcesoAltaSubmenu: async function() {
            const FORMULARIO_VALIDO = this.formularioEsValido();
            //console.log('FORMULARIO_VALIDO::',FORMULARIO_VALIDO);
            if(FORMULARIO_VALIDO) {
                this.formulario.mostrarErrores = false;
                const PETICION_API = await Promise.resolve(this.crearPeticionGuardarSubmenu());
                // SOLO PARA DESARROLLO DESPUES COMENTAR
                for (var pair of PETICION_API.entries()) {
                    console.log(pair[0]+ ', ',pair[1]); 
                } 
                //
                const ES_NUEVO_SUBMENU = true;
                $("#modal-formulario-submenus").modal('hide');
                await Promise.resolve(this.guardarNuevoSubmenuBD(PETICION_API, ES_NUEVO_SUBMENU));
            }
            else {
                this.formulario.mostrarErrores = true;
            }
        },
        confirmarPerdidaRutaDeAccesoEnPadreDeSubmenu: function () {
            $("#modal-formulario-submenus").modal('hide');
            this.modalInformativo = {
                titulo: 'Mensaje del sistema',
                mensaje: `El menu o submenu al que pertene el submenu cuenta con un acceso (ruta o archivo), si deseas continuar se eliminara el acceso del menu o submenu al que pertenece.
                \n¿Desea continuar?`,
                funcionConfirmar: async () => {
                    $("#modal-informativo-VADSM").modal('hide');
                     const PETICION_API = await Promise.resolve(this.crearPeticionGuardarSubmenu());
                    // SOLO PARA DESARROLLO DESPUES COMENTAR
                    for (var pair of PETICION_API.entries()) {
                        console.log(pair[0]+ ', ',pair[1]); 
                    } 
                    //
                    const ES_NUEVO_SUBMENU = true;
                    $("#modal-formulario-submenus").modal('hide');
                    await Promise.resolve(this.guardarNuevoSubmenuBD(PETICION_API, ES_NUEVO_SUBMENU));
                },
                funcionCancelar: () => {
                    $("#modal-informativo-VADSM").modal('hide');
                    $("#modal-formulario-submenus").modal('show');
                }
            }
            $("#modal-informativo-VADSM").modal('show');
        },
        submenuAlQuePerteneceEsSubmenuPadre: function() {
            let esValido = true;
            const { catalogoMenus, catalogoSubmenu } = this.formulario;
            if(!this.campoRequeridoEsValido(catalogoSubmenu.valorDefinido) && (this.campoRequeridoEsValido(catalogoMenus.valorDefinido) && this.campoRequeridoEsValido(catalogoMenus.menuSeleccionado))) {
                esValido = (!this.campoRequeridoEsValido(catalogoMenus.menuSeleccionado.RutaParaAccesar));
            }
            else if(this.campoRequeridoEsValido(catalogoSubmenu.valorDefinido) && this.campoRequeridoEsValido(catalogoSubmenu.subMenuSeleccionado)) {
                const ULTIMA_SELECCION = this.obtenerUltimaSeleccionValidaHijosDeSubmenu();
                const RUTA_DE_ACCESO = (this.campoRequeridoEsValido(ULTIMA_SELECCION)) ? ULTIMA_SELECCION.RutaParaAccesar : catalogoSubmenu.subMenuSeleccionado.RutaParaAccesar;
                esValido = (!this.campoRequeridoEsValido(RUTA_DE_ACCESO));
            }
            return esValido;
        },
        crearPeticionGuardarSubmenu: async function() {
            const { catalogoMenus, catalogoSubmenu, esSubmenuPadre, titulo, resaltarTitulo, esDescarga, archivo, url, mostrarEnVisor, permiteSubirContenido, iconos } = this.formulario;
            let peticion = new FormData();
            let submenuObj = {};
            submenuObj.SubmenuId = -1;
            submenuObj.Titulo = this.validarYObtenerValor(titulo);
            submenuObj.ResaltarElTitulo = resaltarTitulo;
            /* submenuObj.RutaParaAccesar = (esSubmenuPadre) ? null : (esDescarga && archivo.esConSubidor) ? archivo.IDENTIFICADOR : url; */
            submenuObj.RutaParaAccesar = (esDescarga && archivo.esConSubidor) ? archivo.IDENTIFICADOR : url;
            submenuObj.EsDescarga = esDescarga;
            submenuObj.SeMuestraEnVisor = mostrarEnVisor;
            submenuObj.Activo = true;
            submenuObj.OrdenDelSubmenu = -1;
            /* submenuObj.PermiteSubirContenido = (!esSubmenuPadre) ? permiteSubirContenido : false; */
            submenuObj.PermiteSubirContenido = permiteSubirContenido;
            let iconoObj = null;
            if(this.campoRequeridoEsValido(iconos.seleccionado)) {
                iconoObj = { TipoIconoId: iconos.seleccionado.llave, Icono: null, UsablePorUsuario: false, Activo : false } // solo requerido el atributo TipoIconoId
            }
            submenuObj.TipoIcono = iconoObj;
            let menuObj = null;
            // si pertece a algun submenu no se asigna el valor del menu para que no se muestre en el menu
            if(!this.campoRequeridoEsValido(catalogoSubmenu.valorDefinido) && this.campoRequeridoEsValido(catalogoMenus.valorDefinido)) {
                menuObj = { MenuId: catalogoMenus.valorDefinido, EsDescarga: false, Activo: false, EsMenuEspecial: false, ElMenuParpadea: false }; // solo requerido el atributo MenuId
            }
            submenuObj.Menu = menuObj;
            submenuObj.SubmenusQueMePertenecen = [];
            let submenuQuePertene = null;
            console.log('catalogoSubmenu.valorDefinido::',catalogoSubmenu.valorDefinido)
            if(this.campoRequeridoEsValido(catalogoSubmenu.valorDefinido)) {
                const ULTIMA_SELECCION = this.obtenerUltimaSeleccionValidaHijosDeSubmenu();
                // si tiene un submenu hijo seleccionado se asigna 
                submenuQuePertene = (this.campoRequeridoEsValido(ULTIMA_SELECCION)) ?
                    ULTIMA_SELECCION :
                    { SubmenuId: catalogoSubmenu.valorDefinido, ResaltarElTitulo: false, EsDescarga: false, SeMuestraEnVisor: false, Activo: false, PermiteSubirContenido: false };
            }

            submenuObj.SubmenuAlQuePertenezco = submenuQuePertene;
            submenuObj.PaginasWeb = [];
            submenuObj.SeccionDeLaPaginaWeb = null;
            submenuObj.ContenidoDeLaPaginaWeb = null;
            // informacion referente para el archivo del submenu
            peticion.append('ReferenciaArchivo',archivo.IDENTIFICADOR);
            /* if(!esSubmenuPadre && esDescarga && archivo.esConSubidor && this.campoRequeridoEsValido(archivo.objeto)) */
            if(esDescarga && archivo.esConSubidor && this.campoRequeridoEsValido(archivo.objeto))
                peticion.append(archivo.IDENTIFICADOR,archivo.objeto);
            // 
            peticion.append('Submenu',JSON.stringify(submenuObj));
            /* peticion.append('RemoverRutaDeAcceso', cambiarRutaDeAccesoEnPadre); */
            peticion.append('EsPrueba',false);
            return peticion;
        },
        crearPeticionModificarSubmenu: async function() {
            const { mostrarOpcionesHerencia, catalogoMenus, catalogoSubmenu, esSubmenuPadre, titulo, resaltarTitulo, esDescarga, archivo, url, mostrarEnVisor, permiteSubirContenido, iconos, esConSubidor } = this.formulario;
            let peticion = new FormData();
            let submenuObj = {...this.submenus.seleccionadoEdicion};
            submenuObj.Titulo = this.validarYObtenerValor(titulo);
            submenuObj.ResaltarElTitulo = resaltarTitulo;
            submenuObj.RutaParaAccesar = (esDescarga) ? (archivo.esConSubidor) ? archivo.IDENTIFICADOR : submenuObj.RutaParaAccesar : url;
            submenuObj.EsDescarga = esDescarga;
            submenuObj.SeMuestraEnVisor = mostrarEnVisor;
            submenuObj.PermiteSubirContenido = permiteSubirContenido;

            if(this.campoRequeridoEsValido(iconos.seleccionado)) {
                let iconoObj = { TipoIconoId: iconos.seleccionado.llave, Icono: null, UsablePorUsuario: false, Activo : false } // solo requerido el atributo TipoIconoId
                submenuObj.TipoIcono = iconoObj;
            }
            
            // si pertece a algun submenu no se asigna el valor del menu para que no se muestre en el menu
            submenuObj.Menu = (mostrarOpcionesHerencia) ? null : submenuObj.Menu;
            submenuObj.SubmenuAlQuePertenezco = (mostrarOpcionesHerencia) ? null : submenuObj.SubmenuAlQuePertenezco;

            if(mostrarOpcionesHerencia && !this.campoRequeridoEsValido(catalogoSubmenu.valorDefinido) && this.campoRequeridoEsValido(catalogoMenus.valorDefinido)) {
                let menuObj = { MenuId: catalogoMenus.valorDefinido, EsDescarga: false, Activo: false, EsMenuEspecial: false, ElMenuParpadea: false }; // solo requerido el atributo MenuId
                submenuObj.Menu = menuObj;
            }

            if(mostrarOpcionesHerencia && this.campoRequeridoEsValido(catalogoSubmenu.valorDefinido)) {
                const ULTIMA_SELECCION = this.obtenerUltimaSeleccionValidaHijosDeSubmenu();
                // si tiene un submenu hijo seleccionado se asigna 
                let submenuQuePertene = (this.campoRequeridoEsValido(ULTIMA_SELECCION)) ?
                    ULTIMA_SELECCION :
                    { SubmenuId: catalogoSubmenu.valorDefinido, ResaltarElTitulo: false, EsDescarga: false, SeMuestraEnVisor: false, Activo: false, PermiteSubirContenido: false };
                submenuObj.SubmenuAlQuePertenezco = submenuQuePertene;
            }

            peticion.append('ReferenciaArchivo',archivo.IDENTIFICADOR);
            if(esDescarga && archivo.esConSubidor && this.campoRequeridoEsValido(archivo.objeto))
                peticion.append(archivo.IDENTIFICADOR,archivo.objeto);

            peticion.append('Submenu',JSON.stringify(submenuObj));
            peticion.append('RemoverSubmenuHijos', !esSubmenuPadre);
            peticion.append('ActualizarOrdenDeSubmenu', mostrarOpcionesHerencia);
            peticion.append('EsPrueba',false);
            return peticion;
        },
        validarYObtenerValor: function(campoAValidar) {
            return (this.campoRequeridoEsValido(campoAValidar)) ? campoAValidar : null;
        },
        perteneAEsValido: function() {
            const { catalogoMenus, catalogoSubmenu } = this.formulario;
            let padreDeSubmenu = null;
            if(this.campoRequeridoEsValido(catalogoMenus.valorDefinido) && !this.campoRequeridoEsValido(catalogoSubmenu.valorDefinido))
                    padreDeSubmenu = catalogoMenus.valorDefinido;
            else if(this.campoRequeridoEsValido(catalogoSubmenu.valorDefinido)) {
                const ULTIMA_SELECCION = this.obtenerUltimaSeleccionValidaHijosDeSubmenu();
                padreDeSubmenu = (this.campoRequeridoEsValido(ULTIMA_SELECCION)) ? ULTIMA_SELECCION.SubmenuId : catalogoSubmenu.valorDefinido;
            }
            return this.campoRequeridoEsValido(padreDeSubmenu);
        },
        formularioEsValido: function() { debugger
            let esValido = true;
            const { esEdicion, mostrarOpcionesHerencia, esSubmenuPadre, catalogoMenus, catalogoSubmenu, titulo, archivo, url, esDescarga } = this.formulario;
            let inputAccesoDeSubmenu = (!esEdicion) 
                                        ? (esDescarga) ? archivo.objeto :url 
                                        : (esDescarga) ? (archivo.esConSubidor) ? archivo.objeto : this.submenus.seleccionadoEdicion.RutaParaAccesar
                                                       :url;
            let camposObligatorios = [];

            if(mostrarOpcionesHerencia) {
                let padreDeSubmenu = null;
                if(this.campoRequeridoEsValido(catalogoMenus.valorDefinido) && !this.campoRequeridoEsValido(catalogoSubmenu.valorDefinido))
                    padreDeSubmenu = catalogoMenus.valorDefinido;
                else if(this.campoRequeridoEsValido(catalogoSubmenu.valorDefinido)) {
                    const ULTIMA_SELECCION = this.obtenerUltimaSeleccionValidaHijosDeSubmenu();
                    padreDeSubmenu = (this.campoRequeridoEsValido(ULTIMA_SELECCION)) ? ULTIMA_SELECCION.SubmenuId : catalogoSubmenu.valorDefinido;

                    if(esEdicion && (this.campoRequeridoEsValido(padreDeSubmenu))) {
                        if(this.campoRequeridoEsValido(this.submenus.seleccionadoEdicion) && this.submenus.seleccionadoEdicion.SubmenuId == padreDeSubmenu) {
                            esValido = false;
                            this.formulario.mensajeError = `Submenu [${ this.submenus.seleccionadoEdicion.Titulo }] no puede pertenecer asi mismo, revisa la sección 'Submenu pertenece a (*)' del formulario.`;
                            return;
                        }
                    }
                }
                camposObligatorios.push({ valor: padreDeSubmenu, msjError: 'Debes seleccionar un menu o submenu valido.' });
            }

            camposObligatorios.push({ valor: titulo, msjError: 'Debes ingresar un titulo para el submenu valido.' });

            if(!esSubmenuPadre) 
                camposObligatorios.push({ valor: inputAccesoDeSubmenu, msjError:  `Debes ${ (esDescarga) ? 'seleccionar un archivo valido.' : 'ingresar un url valido' }` });

            console.log('camposObligatorios::',camposObligatorios);
            for (let i = 0; i < camposObligatorios.length; i++) {
                let input = camposObligatorios[i];
                if(!this.campoRequeridoEsValido(input.valor)) {
                    esValido = false;
                    this.formulario.mensajeError = input.msjError;
                    break;
                }
            }
            console.log('mensajeError::',this.formulario.mensajeError);
            return esValido;
        },
        limpiarFormulario: function() {
            this.formulario.esEdicion = false;
            this.formulario.tituloFormulario = 'Formulario alta de submenu';
            this.formulario.mostrarErrores = false;
            this.formulario.mensajeError = null;
            this.limpiarCamposCatalogoMenus();
            this.formulario.esSubmenuPadre = false;
            this.limpiarCamposCatalogoSubmenus();
            this.formulario.titulo = null;
            this.formulario.resaltarTitulo = false;
            this.formulario.esDescarga = false;
            this.limpiarCamposArchivoDeSubmenu();
            this.formulario.url = null;
            this.formulario.mostrarEnVisor = false;
            this.formulario.permiteSubirContenido = false;
            this.limpiarCamposIconoDeSubmenu();
            this.formulario.esEdicion = false;
            this.formulario.mostrarOpcionesHerencia = true;
            this.submenus.seleccionadoEdicion = null;
        },
        limpiarCamposIconoDeSubmenu: function() {
            this.formulario.iconos.seleccionado = null;
            this.formulario.iconos.contRender ++;
        },
        limpiarCamposCatalogoSubmenus: function() {
            this.formulario.catalogoSubmenu.valorDefinido = -1;
            this.formulario.catalogoSubmenu.subMenuSeleccionado = null;
            this.formulario.catalogoSubmenu.contRender ++;
        },
        limpiarHijosDeSubmenu: function() {
            this.formulario.catalogoSubmenu.hijos.seleccionado = null;
            this.formulario.catalogoSubmenu.hijos.historialDeSeleccion = [];
        },
        limpiarCamposCatalogoMenus: function() {
            this.formulario.catalogoMenus.valorDefinido = -1;
            this.formulario.catalogoMenus.menuSeleccionado = null;
            this.formulario.catalogoMenus.contRender ++;
        },
        limpiarCamposArchivoDeSubmenu: function() {
            this.formulario.archivo.esConSubidor = false;
            this.formulario.archivo.objeto = null;
            $("#archivo_submenu").val('');
        },
        evtSubidorDeArchivo: function(evento) {
            try{
                if(evento.target.files.length > 0) {
                    //const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                    const ARCHIVO = evento.target.files[0];
                    this.formulario.archivo.objeto = ARCHIVO;
                    this.formulario.archivo.esConSubidor = true;
                }
                else {
                    this.formulario.archivo.objeto = null;
                    this.formulario.archivo.esConSubidor = false;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        evtCambioMenu: function(evento, menuObjeto) {
            this.formulario.catalogoMenus.valorDefinido = parseInt(evento.target.value);
            this.formulario.catalogoMenus.menuSeleccionado = menuObjeto;

            // se actualiza catalogo de submenus
            this.formulario.catalogoSubmenu.parametros.MenuId = this.campoRequeridoEsValido(this.formulario.catalogoMenus.valorDefinido) ?
                    this.formulario.catalogoMenus.valorDefinido : null;
            this.formulario.catalogoSubmenu.valorDefinido = -1;      
            this.formulario.catalogoSubmenu.contRender ++;
            this.formulario.catalogoSubmenu.subMenuSeleccionado = null;

            // se limpia el valor del submenu hijo en caso de que tenga uno asignado
            this.formulario.catalogoSubmenu.hijos.seleccionado = null; 
            this.formulario.catalogoSubmenu.hijos.historialDeSeleccion = [];
        },
        evtCambioSubmenu: function(evento, subMenuObjeto) {
            this.formulario.catalogoSubmenu.valorDefinido = parseInt(evento.target.value);
            this.formulario.catalogoSubmenu.subMenuSeleccionado = subMenuObjeto;

            // se limpia el valor del submenu hijo en caso de que tenga uno asignado
            this.formulario.catalogoSubmenu.hijos.seleccionado = null; 
            this.formulario.catalogoSubmenu.hijos.historialDeSeleccion = [];
            console.log('subMenuObjeto::',subMenuObjeto);
        }, 
        evtMostrarFormulario: async function() {
            this.formulario.esEdicion = false;
            this.formulario.mostrarOpcionesHerencia = true;
            await Promise.resolve(this.llenarFormulario());
            $("#modal-formulario-submenus").modal('show');
        },
        llenarFormulario: async function() {
            await Promise.resolve(this.llenarCamposMenuEnFormulario());
        },
        llenarCamposMenuEnFormulario: async function() {
            // caso de edicion aqui
        },

        confirmarTomarValoresDeBusqueda: function () {
            this.modalInformativo = {
                titulo: 'Mensaje del sistema',
                mensaje: `\n¿Desea continuar?`,
                funcionConfirmar: () => {
                    $("#modal-informativo-VADSM").modal('hide');
                },
                funcionCancelar: () => {
                    $("#modal-informativo-VADSM").modal('hide');
                }
            }
            $("#modal-informativo-VADSM").modal('show');
        },
        evtRealizarBusquedaDeSubmenus: async function(filtros) {
            console.log('FILTROS::',filtros);
            this.submenus.filtrosDeBusqueda = filtros;
            const ES_PARA_ACTUALIZAR = false;
            const MENSAJE_DE_ACTUALIZACION = null;
            this.submenus.tituloPadreSubmenu = (this.campoRequeridoEsValido(this.submenus.filtrosDeBusqueda.submenuAlQuePertenece)) ? 'menu' : 'submenú';
            // se limpian las variables de ordenamiento
            this.ordenamiento.listaOrdenamiento = [];
            this.ordenamiento.listaNuevoOrden = [];
            await Promise.resolve(this.obtenerSubmenusBD(ES_PARA_ACTUALIZAR, MENSAJE_DE_ACTUALIZACION));
        },
        obtenerSubmenusBD: async function(esDespuesDeActualizacion, mensajeDeActualizacion) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.paginaweb.administracionDeSubmenus.ObtenerSubmenusPW;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionArchivos = false;
                const PETICION_API = {
                    MenuId: (!this.campoRequeridoEsValido(this.submenus.filtrosDeBusqueda.submenuAlQuePertenece)) ? this.submenus.filtrosDeBusqueda.menuId : null,
                    TituloSubmenu: this.submenus.filtrosDeBusqueda.tituloSubmenu,
                    SubmenuAlQuePertenece: this.campoRequeridoEsValido(this.submenus.filtrosDeBusqueda.submenuAlQuePertenece) ? this.submenus.filtrosDeBusqueda.submenuAlQuePertenece.SubmenuId : null,
                    EsDescarga: this.submenus.filtrosDeBusqueda.esDescarga,
                    SeMuestraEnVisor: this.submenus.filtrosDeBusqueda.seMuestraEnVisor,
                    esPrueba: false
                }
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                if(!esDespuesDeActualizacion)
                    comun.SeEstaCargandoInformacion(true);
                const PETICION_OBTENER_SUBMENUS = await axios.post(urlApi, PETICION_API, headerPeticion);
                const DATOS_PETICION = await PETICION_OBTENER_SUBMENUS.data;
                let { SiHayError, Error, Satisfactorio, Submenus } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(mensajeError);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    this.submenus.BD = (this.campoRequeridoEsValido(Submenus)) ? Submenus : [];
                    this.ordenamiento.listaOrdenamiento = this.submenus.BD.filter(sbd => sbd.Activo).map(s => {
                        let submenu = { ...s };
                        submenu.Titulo = this.campoRequeridoEsValido(submenu.Menu) 
                            ? `<strong>Pertenece a</strong> : [Menú] - ${ submenu.Menu.Titulo }<br><strong>Submenú</strong>: ${ submenu.Titulo }` 
                            : `<strong>Pertenece a</strong> : [Submenú] - ${ submenu.SubmenuAlQuePertenezco.Titulo }<br><strong>Submenú</strong>: ${ submenu.Titulo }`;
                        submenu.hover = false;
                        return submenu;
                    });
                    console.log('this.submenus.listaOrdenamiento::',this.ordenamiento.listaOrdenamiento);
                    this.$nextTick(async () => {
                        await Promise.resolve(this.construirTablaDeSubmenus(this.submenus.BD));
                        await Promise.resolve(this.persistirSwitchSubmenusActivos());
                    });
                    comun.SeEstaCargandoInformacion(false);
                    if(esDespuesDeActualizacion)
                        comun.mensajeDeAlerta(mensajeDeActualizacion, null, null);
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        persistirSwitchSubmenusActivos: async function() {
            console.log('persistirSwitchSubmenusActivos::',this.submenus.memoria);
            if(this.submenus.memoria.length > 0) {
                this.submenus.memoria.forEach(smObj => {
                    const ID_SWITCH_ACTIVO_SUBMENU = `check-submenu-activo-VASM-${ smObj.SubmenuId }`;
                    $("#" + ID_SWITCH_ACTIVO_SUBMENU).prop('checked',  smObj.EstaActivo.activo);
                });
            }
        },
        formateadorHTMLAcciones: () => {
            return `<div>
                        <button id="editar-submenu-pw-SICPO" type="button" class="btn btn-sm btn-xs btn btn-info texto-ajustable align-middle align-center"><i class="fas fa-edit"></i>&nbsp;Editar</button>
                    </div>`;
        },
        darFormatoObjetosDeSubmenus: async function(submenus) {
            console.log('darFormatoObjetosDeSubmenus::',submenus);
            this.submenus.memoria = submenus.map(smBD => {
                let objSubmenu = {...smBD};
                objSubmenu.EstaActivo = {
                    activo: (objSubmenu.Activo),
                    html: `<label id="switch-activo-inactivo-VASM-${ objSubmenu.SubmenuId }" class="switch-submenu-activo-VASM">
                            <input id="check-submenu-activo-VASM-${ objSubmenu.SubmenuId }" type="checkbox">
                            <div id="slider-activo-inactivo-VASM-${ objSubmenu.SubmenuId }" class="slider-submenu-activo-VASM"></div>
                           </label>`
                };
                objSubmenu.tituloPadre = this.campoRequeridoEsValido(objSubmenu.Menu) 
                    ? `[<strong>Menú</strong>] - ${ objSubmenu.Menu.Titulo }` : `[<strong>Submenú</strong>] - ${ objSubmenu.SubmenuAlQuePertenezco.Titulo }`;
                return objSubmenu;
            });
        },
        limpiarSubmenusSeleccionados: function() {
            this.submenus.seleccionado = null;
            this.submenus.seleccionados = [];
        },
        evtRemoverSubmenusEnListaSeleccionados: function(e, rows, tipoCheck) {
            switch(tipoCheck) {
                case 'UNO':
                    this.submenus.seleccionados = this.submenus.seleccionados.filter(smObj => smObj.SubmenuId != rows.SubmenuId);
                    break;
                case 'MUCHOS':
                    // se remueven la paginacion de submenus seleccionados
                    this.submenus.seleccionados = this.submenus.seleccionados.filter(smObj => {
                        return !rows.some(smRObj => {
                            return smObj.SubmenuId == smRObj.SubmenuId;
                        });
                    });
                    break;
                default:
                    break;
            }
        },
        evtSeleccionoSubmenu: function(e, row) {
            if(!this.submenus.seleccionados.some(smObj => smObj.SubmenuId == row.SubmenuId)) {
                const SUBMENU_ESTRUCTURA_BD = this.submenus.BD.find(smObjBD => smObjBD.SubmenuId == row.SubmenuId);
                this.submenus.seleccionados.push(SUBMENU_ESTRUCTURA_BD);
            }
        },
        evtSeleccionoTodos: function(e, rows) {
            console.log('rows::',rows);
            this.submenus.seleccionados = rows.map(smObj => {
                let submenuObj = {...smObj};
                delete submenuObj['EstaActivo'];
                return submenuObj;
            })
            console.log('RGS::',this.submenus.seleccionados);
        },
        construirTablaDeSubmenus: async function(submenus) {
            this.limpiarSubmenusSeleccionados();
            await Promise.resolve(this.darFormatoObjetosDeSubmenus(submenus));
            $("#tabla-submenus").off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table page-change.bs.table sort.bs.table");
            $("#tabla-submenus").bootstrapTable({  data: this.submenus.memoria });      
            $("#tabla-submenus").bootstrapTable('load',  this.submenus.memoria);  
            $('#tabla-submenus').on('check.bs.table',(e, row) => {
                this.evtSeleccionoSubmenu(e, row);
            });
            $('#tabla-submenus').on('uncheck.bs.table',(e, row) => {
                const TIPO_CHECK = 'UNO';
                this.evtRemoverSubmenusEnListaSeleccionados(e, row,TIPO_CHECK);
            });
            $('#tabla-submenus').on('check-all.bs.table',(e, rows) => {
                this.evtSeleccionoTodos(e, rows);
            });
            $('#tabla-submenus').on('uncheck-all.bs.table',(e, rowsAfter, rowsBefore) => {
                const TIPO_CHECK = 'MUCHOS';
                this.evtRemoverSubmenusEnListaSeleccionados(e, rowsBefore,TIPO_CHECK);
            });
            $('#tabla-submenus').on('page-change.bs.table', (size, number) => {
                //console.log('entro::evento::');
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchSubmenusActivos());
                }); 
            });
            $('#tabla-submenus').on('sort.bs.table', (name, order) => {
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchSubmenusActivos());
                });
            });
            // bs table no reconoce clases css del componenete, una vez que se cargan los datos se asigna las clases de de manera global 
            $("td[id^=switch-activo-inactivo-VASM]").addClass('switch-submenu-activo-VASM');
            $("td[id^=slider-activo-inactivo-VASM]").addClass('slider-submenu-activo-VASM');
        },
        campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      obtenerIconosPJParaSubmenus: async function() {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.PJ.catalogos.C057TipoIconos;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = {
                    TipoIconoId: null,
                    conInactivos: false,
                    soloUsablePorUsuario: false,
                    esPrueba: false
                }
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_GET_ICONOS = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_GET_ICONOS.data;
                let { SiHayError, Error, TiposIconos } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(mensajeError);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    comun.SeEstaCargandoInformacion(false);
                    this.formulario.iconos.lista = await Promise.resolve(this.darFormatoIconosPJ(TiposIconos));
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        darFormatoIconosPJ: async function(iconos) {
            let listaDeIconos = [];
            if(this.campoRequeridoEsValido(iconos)) {
                listaDeIconos = iconos.map(i => {
                    let iconoObj = {};
                    iconoObj.llave = i.TipoIconoId;
                    iconoObj.imagen = i.Icono;
                    return iconoObj;
                });
            }
            return listaDeIconos;
        },
        evtCambiarEstatusSubmenuIndividual: async function(evento, submenu) {
            const ID_CHECK_SUBMENU = evento.target.getAttribute('id');
            const OPCIONES_PETICION = {
                idChekSubmenu: ID_CHECK_SUBMENU,
                submenuSel: submenu
            }
            const PETICON_API = await Promise.resolve(this.crearPeticioParaCambioDeEstatusSubmenus(OPCIONES_PETICION));
            console.log('PETICON_API::cambioestatus::',PETICON_API);
            const ES_CAMBIO_INDIVIDUAL = true;
            this.cambiarEstatusDeSubmenusBD(PETICON_API, ES_CAMBIO_INDIVIDUAL);
        }, 
        crearPeticioParaCambioDeEstatusSubmenus: async function(opciones) {
            let peticion = {};
            if(this.campoRequeridoEsValido(opciones)) {
                const ES_ESTATUS_ACTIVO = $('#' + opciones.idChekSubmenu).is(":checked");
                let submenuObj = {
                    SubmenuId: opciones.submenuSel.SubmenuId,
                    ResaltarElTitulo: false,
                    EsDescarga: false,
                    SeMuestraEnVisor: false,
                    Activo: ES_ESTATUS_ACTIVO,
                    PermiteSubirContenido: false,
                    Menu: opciones.submenuSel.Menu,
                    SubmenuAlQuePertenezco: opciones.submenuSel.SubmenuAlQuePertenezco
                };
                peticion.Submenus = [submenuObj];
            }
            else {
                const ES_ESTATUS_ACTIVO = $('#switch-cambio-estatus-modal-VASM').is(":checked");
                this.submenus.seleccionados = this.submenus.seleccionados.map(smObj => {
                    smObj.Activo = ES_ESTATUS_ACTIVO;
                    return smObj;
                });
                console.log('entro::else::',this.submenus.seleccionados);
                peticion.Submenus = this.submenus.seleccionados;
            }
            peticion.EsPrueba = false;
            return peticion;
        },
        cambiarEstatusDeSubmenusBD: async function(peticionAPI, esContenidoIndividual) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_MODIFICAR = api.SICPO.sistema.paginaweb.administracionDeSubmenus.CambiarEstatusDeSubmenusPW;
                let urlApi = SERVIDOR + METODO_API_MODIFICAR;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_ESTATUS = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_ESTATUS.data;
                let { SiHayError, Error, Satisfactorio, Submenus } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(mensajeError);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                    if(!esContenidoIndividual)
                        this.evtMostrarModalCambioEstatus();
                } 
                else {
                    if(!esContenidoIndividual)
                        this.limpiarModalEstatus();
                    const ES_DESPUES_DE_ACTUALIZACION = true;
                    await Promise.resolve(this.obtenerSubmenusBD(ES_DESPUES_DE_ACTUALIZACION, Satisfactorio));
                    /* if(esContenidoIndividual) {
                        await Promise.resolve(this.persistirSwitchSubmenusActivos());
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(Satisfactorio);
                    }
                    else {
                         await Promise.resolve(this.obtenerSubmenusBD(ES_DESPUES_DE_ACTUALIZACION, Satisfactorio));
                         this.limpiarModalEstatus();
                    } */
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        limpiarModalEstatus: function() {
            this.submenus.activarVariosSubmenus = false;
            this.$nextTick(() => {
                $("#switch-cambio-estatus-modal-VASM").prop('checked',false);
            });
        },
    },
    mounted() {
        this.$nextTick(() => {
            $("#tabla-submenus").bootstrapTable({  data: this.submenus.BD });      
            $("#tabla-submenus").bootstrapTable('load',  this.submenus.BD); 
        });
        window.operateEvents = {
            "click #editar-submenu-pw-SICPO": (e,val,row,index) => {          
                this.cargarFormularioParaModificaciones(row);
            },
            "click #eliminar-contenido-pw-SICPO": (e,val,row,index) => {          
                //this.evtEliminarContenido(row)
            },
            "click #eliminar-archivo-pw-SICPO": (e,val,row,index) => {          
                /* $("#tabla-archivos-contenido").bootstrapTable('remove', {
                    field: 'RutaDelArchivo',
                    values: [row.RutaDelArchivo]
                });
                this.formulario.archivos.identificadoresDeArchivos = this.formulario.archivos.identificadoresDeArchivos.filter(ia => ia.llave != row.RutaDelArchivo);
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchArchivosActivos());
                }); */
                /* console.log('archivos::',this.formulario.archivos.lista);
                console.log('identificadores::',this.formulario.archivos.identificadoresDeArchivos); */
            },
            "click #descargar-archivo-SICPO": (e,val,row,index) => {   
                /* if(row.ArchivoDeContenidoDeLaPaginaWebId > 0)       
                    this.evtDescargarArchivo(row.RutaDelArchivo)
                else
                    this.evtDescargarArchivoEnMemoria(row); */
            },
            'click :checkbox[id^=check-submenu-activo-VASM]': (e, value, row, index) => {
                this.evtCambiarEstatusSubmenuIndividual(e,row);
            },
            'click .icono-ampliar-texto': (e, value, row, index) => {
               // this.mostrarTextoDeContenidoCompleto(row, index);
            },
        };
    },
    async created() {
        await Promise.resolve(this.obtenerIconosPJParaSubmenus());
        const PAGINA_OFICIAL_ID = 1;
        this.formulario.catalogoMenus.parametros.PaginaDeInicioId = PAGINA_OFICIAL_ID;
    },
}
</script>
<style scoped>
.thead-encabezado{
    background-color: var(--verde-pj-100);
    color: white;

}
#lista-ordenamiento-submenus {
    border: 2px solid rgb(51, 49, 49);
    max-height: 335px;
    overflow: auto;
}

#modal-cambio-estatus-VASM .modal-lg {
    max-width: 25% !important;
}

#modal-cambio-estatus-VASM .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-cambio-estatus-VASM .modal-dialog {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
}

#modal-ordenamiento-submenusPW .modal-lg {
    max-width: 45% !important;
}

#modal-ordenamiento-submenusPW .modal-header {
    background-color: rgb(36, 34, 34);
    border: none;
}

#modal-ordenamiento-submenusPW .modal-dialog {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
}

.acciones-activacion-submenus .btn-block{
    height: 45px;
    background-color: black;
}

.icono-activacion-submenus {
    font-size : 4vw;
}

#accion-estatus-submenus h6:hover, #accion-estatus-submenus h6:focus {
    text-decoration-line: underline;
    font-weight: bold;
    cursor: pointer;
}

#contenedor-error-formulario {
    padding: 1em;
    background-color: #26272b;
    border: 1px solid #5c5959;
    border-radius: 8px;
    margin-bottom: 1em;;
}

.btn-secondary:not(:disabled):not(.disabled).active, 
.btn-secondary:not(:disabled):not(.disabled):active, .show > #opciones-toggle .btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

.btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size : 1vw;
}

.btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

#modal-informativo-VADSM .modal-lg {
    max-width: 30% !important;
}

#modal-informativo-VADSM .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-formulario-submenus .modal-lg {
    max-width: 50% !important;
}

#modal-formulario-submenus .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

#tabla-submenus-SICPO-VADSM table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

.seccion-filtrosDeBusqueda {
    margin-top: 3.5em;
}
.contenedor-gris {
    background-color: var(--gris-pj-100);
    border:.2em  solid var(--gris-pj);
    padding: 25px;
}

.titulo-contendor {
    background-color: rgb(0,117,115);
    padding: 13px 13px 5px 23px;
    /* border:solid .2em var(--verde-pj-100); */
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;   
}

.titulo-contendor h4{
    color: white;
}


.titulo-tabla {
    background-color: rgb(0,117,115);
    padding: 13px 13px 13px 23px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;  
}

.titulo-tabla h4{
    color: white;
}

/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch {
  position: relative;
  width: 60px;
  height: 34px;
}

.switch input {display:none;}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ca2222;
  -webkit-transition: .2s;
  transition: .2s;
   border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 50%;
}

.switch input:checked + .slider {
  background-color: #2ab934;
}

.switch:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

.switch input:checked + .slider:before {
  -webkit-transform: translateX(25px);
  -ms-transform: translateX(25px);
  transform: translateX(25px);
}

.slider:after
{
 content:'';
 color: white;
 display: block;
 position: absolute;
 transform: translate(-50%,-50%);
 top: 50%;
 left: 50%;
 font-size: 10px;
 font-family: Verdana, sans-serif;
}

.switch input:checked + .slider:after
{  
  content:'';
}
</style>
<style>
#tabla-submenus-SICPO-VADSM .search {
    width: 20rem;
}

#tabla-submenus-SICPO-VADSM .dropdown-toggle {
    width: 3.3rem;
}

/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch-submenu-activo-VASM {
  position: relative;
  top: 5px;
  width: 40px;
  height: 24px;
}

.switch-submenu-activo-VASM input {display:none;}

.slider-submenu-activo-VASM {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ca2222;
  -webkit-transition: .2s;
  transition: .2s;
   border-radius: 34px;
}

.slider-submenu-activo-VASM:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 50%;
}

.switch-submenu-activo-VASM input:checked + .slider-submenu-activo-VASM {
  background-color: #2ab934;
}

.switch-submenu-activo-VASM input:focus + .slider-submenu-activo-VASM {
  box-shadow: 0 0 1px #2196F3;
}

.switch-submenu-activo-VASM input:checked + .slider-submenu-activo-VASM:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}

.slider-submenu-activo-VASM:after
{
 content:'';
 color: white;
 display: block;
 position: absolute;
 transform: translate(-50%,-50%);
 top: 50%;
 left: 50%;
 font-size: 10px;
 font-family: Verdana, sans-serif;
}

.switch-submenu-activo-VASM input:checked + .slider-submenu-activo-VASM:after
{  
  content:'';
}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/Submenus/CAdministracionDeSubmenus.vue